// Generated by ReScript, PLEASE EDIT WITH CARE

import * as View from "../../primitives/View.res.js";
import * as React from "react";
import * as Spaces from "../theme/Spaces.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  root: {
    "display-k1xSpc": "display-x78zum5",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    $$css: "wino-gc:src/resources/layout-and-structure/Box.res.js:13"
  },
  grow: {
    "flex-kUk6DE": "flex-x98rzlu",
    $$css: "wino-gc:src/resources/layout-and-structure/Box.res.js:17"
  }
};
function styleFromSpace(spaceX, spaceY) {
  let styles = [];
  let styles$1 = spaceX !== undefined ? Belt_Array.concatMany([styles, [{
    paddingInline: Spaces.toPx(spaceX)
  }]]) : styles;
  if (spaceY !== undefined) {
    return Belt_Array.concatMany([styles$1, [{
      paddingBlock: Spaces.toPx(spaceY)
    }]]);
  } else {
    return styles$1;
  }
}
function styleExceptionFromSpace(spaceTop, spaceBottom, spaceLeft, spaceRight) {
  let styles = [];
  let styles$1 = spaceTop !== undefined ? Belt_Array.concatMany([styles, [{
    paddingTop: Spaces.toPx(spaceTop)
  }]]) : styles;
  let styles$2 = spaceBottom !== undefined ? Belt_Array.concatMany([styles$1, [{
    paddingBottom: Spaces.toPx(spaceBottom)
  }]]) : styles$1;
  let styles$3 = spaceLeft !== undefined ? Belt_Array.concatMany([styles$2, [{
    paddingLeft: Spaces.toPx(spaceLeft)
  }]]) : styles$2;
  if (spaceRight !== undefined) {
    return Belt_Array.concatMany([styles$3, [{
      paddingRight: Spaces.toPx(spaceRight)
    }]]);
  } else {
    return styles$3;
  }
}
function styleProps(spaceX, spaceY, spaceTop, spaceBottom, spaceLeft, spaceRight, grow, additionalStyle) {
  return Stylex.props(styles.root, styleFromSpace(spaceX, spaceY), styleExceptionFromSpace(spaceTop, spaceBottom, spaceLeft, spaceRight), grow ? styles.grow : {}, additionalStyle);
}
let make = React.forwardRef((props, ref) => {
  let __style = props.style;
  let __grow = props.grow;
  let children = props.children;
  let grow = __grow !== undefined ? __grow : false;
  let style = __style !== undefined ? Primitive_option.valFromOption(__style) : {};
  let ref$1 = Stdlib_Option.map(ref == null ? undefined : Primitive_option.some(ref), prim => prim);
  let blankContent = children !== undefined ? React.Children.toArray(children).every(element => element === null) : false;
  let stylePropsResult = styleProps(props.spaceX, props.spaceY, props.spaceTop, props.spaceBottom, props.spaceLeft, props.spaceRight, grow, style);
  let style$1 = stylePropsResult.style;
  let className = stylePropsResult.className;
  if (blankContent) {
    return null;
  } else {
    return JsxRuntime.jsx(View.make, {
      children: children !== undefined ? children : null,
      ref: ref$1,
      className: className,
      style: style$1
    });
  }
});
export { make };
/* styles Not a pure module */